const BASE_DECORATIONS = [
  { type: 'crate', x: 52, y: 564 },
  { type: 'crate', x: 326, y: 484 },
  { type: 'sandbag', x: 54, y: 236 },
  { type: 'sandbag', x: 306, y: 306 },
  { type: 'rock', x: 312, y: 198 },
  { type: 'rock', x: 62, y: 92 },
];

const BASE_PATCHES = [
  { x: 86, y: 112, width: 86, height: 54, color: 0xe5d391, alpha: 0.52 },
  { x: 264, y: 166, width: 112, height: 48, color: 0xb58b55, alpha: 0.28 },
  { x: 92, y: 382, width: 116, height: 62, color: 0xe0bd74, alpha: 0.34 },
  { x: 274, y: 508, width: 92, height: 72, color: 0x9e7b51, alpha: 0.34 },
];

const BASE_TERRAINS = [
  { id: 'main-road', type: 'road', x: 292, y: 330, width: 62, height: 500, speedMultiplier: 1.08 },
  { id: 'lower-mud', type: 'mud', x: 254, y: 474, width: 96, height: 74, speedMultiplier: 0.72 },
  { id: 'upper-trench', type: 'trench', x: 252, y: 274, width: 106, height: 58, speedMultiplier: 0.62 },
];

export const RANGER_LEVELS = [
  {
    id: 'level-01',
    name: 'Flag Run',
    objectiveText: 'Reach the flag and capture it.',
    objectiveType: 'flag',
    width: 360,
    height: 640,
    playerSpawn: { x: 300, y: 580 },
    flag: { x: 300, y: 80, width: 38, height: 48 },
    groundPatches: BASE_PATCHES,
    terrains: BASE_TERRAINS,
    decorations: BASE_DECORATIONS,
    obstacles: [
      { x: 88, y: 516, width: 116, height: 24 },
      { x: 180, y: 422, width: 132, height: 24 },
      { x: 88, y: 328, width: 112, height: 24 },
      { x: 178, y: 228, width: 132, height: 24 },
    ],
    enemies: [
      { x: 110, y: 278, axis: 'horizontal', range: 54, speed: 24, visionRange: 150, visionAngle: 58, attackCooldownMs: 1120 },
      { x: 262, y: 178, axis: 'vertical', range: 42, speed: 22, visionRange: 136, visionAngle: 52, attackCooldownMs: 1250, health: 1 },
    ],
  },
  {
    id: 'level-02',
    name: 'Canal Rescue',
    objectiveText: 'Reach the scout, then escort them to the flare.',
    objectiveType: 'rescue',
    width: 360,
    height: 640,
    playerSpawn: { x: 58, y: 578 },
    ally: { x: 84, y: 94, width: 34, height: 38 },
    flag: { x: 304, y: 78, width: 40, height: 48 },
    groundPatches: BASE_PATCHES,
    terrains: [
      { id: 'canal-road', type: 'road', x: 90, y: 330, width: 58, height: 490, speedMultiplier: 1.06 },
      { id: 'canal-mud', type: 'mud', x: 214, y: 356, width: 98, height: 180, speedMultiplier: 0.74 },
      { id: 'canal-trench', type: 'trench', x: 254, y: 190, width: 116, height: 54, speedMultiplier: 0.64 },
    ],
    decorations: BASE_DECORATIONS,
    obstacles: [
      { x: 210, y: 526, width: 132, height: 24 },
      { x: 140, y: 430, width: 110, height: 24 },
      { x: 250, y: 322, width: 120, height: 24 },
      { x: 136, y: 224, width: 112, height: 24 },
    ],
    enemies: [
      { x: 254, y: 476, axis: 'vertical', range: 62, speed: 26, visionRange: 154, visionAngle: 58, attackCooldownMs: 1080 },
      { x: 214, y: 254, axis: 'horizontal', range: 52, speed: 24, visionRange: 146, visionAngle: 54, attackCooldownMs: 1220 },
      { x: 118, y: 156, axis: 'horizontal', range: 36, speed: 20, visionRange: 132, visionAngle: 50, attackCooldownMs: 1320, health: 1 },
    ],
  },
  {
    id: 'level-03',
    name: 'Depot Sabotage',
    objectiveText: 'Sabotage the depot crate, then reach extraction.',
    objectiveType: 'sabotage',
    width: 360,
    height: 640,
    playerSpawn: { x: 62, y: 578 },
    target: { x: 284, y: 332, width: 42, height: 42 },
    flag: { x: 310, y: 84, width: 40, height: 48 },
    groundPatches: BASE_PATCHES,
    terrains: [
      { id: 'depot-road', type: 'road', x: 292, y: 346, width: 58, height: 462, speedMultiplier: 1.04 },
      { id: 'depot-yard', type: 'mud', x: 140, y: 344, width: 120, height: 120, speedMultiplier: 0.78 },
      { id: 'depot-trench', type: 'trench', x: 92, y: 190, width: 116, height: 54, speedMultiplier: 0.64 },
    ],
    decorations: [
      ...BASE_DECORATIONS,
      { type: 'crate', x: 286, y: 278 },
      { type: 'crate', x: 320, y: 366 },
    ],
    obstacles: [
      { x: 118, y: 520, width: 122, height: 24 },
      { x: 184, y: 422, width: 118, height: 24 },
      { x: 92, y: 292, width: 106, height: 24 },
      { x: 198, y: 198, width: 112, height: 24 },
    ],
    enemies: [
      { x: 118, y: 382, axis: 'vertical', range: 72, speed: 28, visionRange: 154, visionAngle: 58 },
      { x: 250, y: 226, axis: 'horizontal', range: 58, speed: 26, visionRange: 150, visionAngle: 56 },
    ],
  },
  {
    id: 'level-04',
    name: 'Ridge Escape',
    objectiveText: 'Slip through patrols and reach the north exit.',
    objectiveType: 'escape',
    width: 360,
    height: 640,
    playerSpawn: { x: 300, y: 578 },
    flag: { x: 58, y: 80, width: 42, height: 50 },
    groundPatches: BASE_PATCHES,
    terrains: [
      { id: 'ridge-road', type: 'road', x: 94, y: 334, width: 58, height: 496, speedMultiplier: 1.08 },
      { id: 'ridge-mud', type: 'mud', x: 248, y: 432, width: 112, height: 106, speedMultiplier: 0.72 },
      { id: 'ridge-trench', type: 'trench', x: 218, y: 252, width: 122, height: 58, speedMultiplier: 0.62 },
    ],
    decorations: BASE_DECORATIONS,
    obstacles: [
      { x: 216, y: 526, width: 118, height: 24 },
      { x: 146, y: 422, width: 128, height: 24 },
      { x: 246, y: 326, width: 120, height: 24 },
      { x: 146, y: 218, width: 124, height: 24 },
      { x: 256, y: 130, width: 96, height: 24 },
    ],
    enemies: [
      { x: 96, y: 476, axis: 'vertical', range: 70, speed: 30, visionRange: 160, visionAngle: 58 },
      { x: 254, y: 378, axis: 'horizontal', range: 58, speed: 28, visionRange: 150, visionAngle: 56 },
      { x: 156, y: 162, axis: 'horizontal', range: 56, speed: 28, visionRange: 146, visionAngle: 54 },
    ],
  },
  {
    id: 'level-05',
    name: 'Command Post',
    objectiveText: 'Disable both relays, then capture the command flag.',
    objectiveType: 'multi-sabotage',
    width: 360,
    height: 640,
    playerSpawn: { x: 180, y: 582 },
    targets: [
      { x: 74, y: 230, width: 38, height: 38 },
      { x: 286, y: 428, width: 38, height: 38 },
    ],
    flag: { x: 180, y: 76, width: 44, height: 52 },
    groundPatches: BASE_PATCHES,
    terrains: [
      { id: 'post-road', type: 'road', x: 180, y: 330, width: 62, height: 500, speedMultiplier: 1.06 },
      { id: 'post-mud-a', type: 'mud', x: 92, y: 460, width: 92, height: 86, speedMultiplier: 0.74 },
      { id: 'post-mud-b', type: 'mud', x: 268, y: 236, width: 92, height: 86, speedMultiplier: 0.74 },
      { id: 'post-trench', type: 'trench', x: 180, y: 314, width: 132, height: 60, speedMultiplier: 0.62 },
    ],
    decorations: [
      ...BASE_DECORATIONS,
      { type: 'crate', x: 74, y: 284 },
      { type: 'crate', x: 286, y: 374 },
    ],
    obstacles: [
      { x: 84, y: 524, width: 118, height: 24 },
      { x: 276, y: 524, width: 118, height: 24 },
      { x: 180, y: 420, width: 118, height: 24 },
      { x: 84, y: 326, width: 104, height: 24 },
      { x: 276, y: 326, width: 104, height: 24 },
      { x: 180, y: 188, width: 126, height: 24 },
    ],
    enemies: [
      { x: 92, y: 392, axis: 'vertical', range: 72, speed: 30, visionRange: 158, visionAngle: 58 },
      { x: 268, y: 292, axis: 'vertical', range: 72, speed: 30, visionRange: 158, visionAngle: 58 },
      { x: 180, y: 246, axis: 'horizontal', range: 84, speed: 32, visionRange: 166, visionAngle: 60 },
    ],
  },
  {
    id: 'level-06',
    name: 'Fuel Dump Raid',
    objectiveText: 'Destroy the fuel dump, then reach the flare line.',
    objectiveType: 'sabotage',
    width: 360,
    height: 640,
    playerSpawn: { x: 54, y: 582 },
    target: { x: 290, y: 182, width: 44, height: 44 },
    flag: { x: 64, y: 78, width: 42, height: 50 },
    groundPatches: [
      ...BASE_PATCHES,
      { x: 294, y: 176, width: 86, height: 74, color: 0x4c3b28, alpha: 0.26 },
    ],
    terrains: [
      { id: 'fuel-road', type: 'road', x: 104, y: 332, width: 58, height: 506, speedMultiplier: 1.07 },
      { id: 'fuel-spill', type: 'mud', x: 284, y: 216, width: 104, height: 104, speedMultiplier: 0.7 },
      { id: 'fuel-trench', type: 'trench', x: 216, y: 402, width: 132, height: 58, speedMultiplier: 0.62 },
    ],
    decorations: [
      ...BASE_DECORATIONS,
      { type: 'crate', x: 266, y: 138 },
      { type: 'crate', x: 314, y: 230 },
      { type: 'sandbag', x: 244, y: 176 },
    ],
    obstacles: [
      { x: 170, y: 530, width: 126, height: 24 },
      { x: 276, y: 474, width: 96, height: 24 },
      { x: 108, y: 370, width: 104, height: 24 },
      { x: 236, y: 298, width: 116, height: 24 },
      { x: 116, y: 202, width: 120, height: 24 },
    ],
    enemies: [
      { x: 210, y: 492, axis: 'horizontal', range: 64, speed: 27, visionRange: 160, visionAngle: 58, attackCooldownMs: 1120 },
      { x: 104, y: 308, axis: 'vertical', range: 76, speed: 26, visionRange: 152, visionAngle: 56, attackCooldownMs: 1180 },
      { x: 276, y: 246, axis: 'vertical', range: 66, speed: 24, visionRange: 150, visionAngle: 54, attackCooldownMs: 1260, health: 2 },
    ],
  },
  {
    id: 'level-07',
    name: 'Bridgehead',
    objectiveText: 'Cross the bridgehead and seize the north marker.',
    objectiveType: 'flag',
    width: 360,
    height: 640,
    playerSpawn: { x: 180, y: 582 },
    flag: { x: 180, y: 74, width: 42, height: 50 },
    groundPatches: [
      ...BASE_PATCHES,
      { x: 178, y: 330, width: 126, height: 300, color: 0x6f8d83, alpha: 0.2 },
    ],
    terrains: [
      { id: 'bridge-road', type: 'road', x: 180, y: 330, width: 64, height: 520, speedMultiplier: 1.1 },
      { id: 'west-bank', type: 'mud', x: 72, y: 336, width: 86, height: 430, speedMultiplier: 0.68 },
      { id: 'east-bank', type: 'mud', x: 288, y: 336, width: 86, height: 430, speedMultiplier: 0.68 },
      { id: 'bridge-trench', type: 'trench', x: 180, y: 252, width: 126, height: 56, speedMultiplier: 0.63 },
    ],
    decorations: [
      ...BASE_DECORATIONS,
      { type: 'sandbag', x: 142, y: 444 },
      { type: 'sandbag', x: 218, y: 444 },
      { type: 'rock', x: 74, y: 266 },
      { type: 'rock', x: 290, y: 364 },
    ],
    obstacles: [
      { x: 88, y: 522, width: 98, height: 24 },
      { x: 272, y: 522, width: 98, height: 24 },
      { x: 180, y: 414, width: 118, height: 24 },
      { x: 78, y: 310, width: 96, height: 24 },
      { x: 282, y: 310, width: 96, height: 24 },
      { x: 180, y: 174, width: 128, height: 24 },
    ],
    enemies: [
      { x: 180, y: 470, axis: 'horizontal', range: 86, speed: 28, visionRange: 164, visionAngle: 58 },
      { x: 84, y: 246, axis: 'vertical', range: 76, speed: 25, visionRange: 150, visionAngle: 54, attackCooldownMs: 1240 },
      { x: 284, y: 246, axis: 'vertical', range: 76, speed: 25, visionRange: 150, visionAngle: 54, attackCooldownMs: 1240 },
      { x: 180, y: 128, axis: 'horizontal', range: 54, speed: 23, visionRange: 140, visionAngle: 52, attackCooldownMs: 1320, health: 1 },
    ],
  },
  {
    id: 'level-08',
    name: 'Aid Station Dash',
    objectiveText: 'Find the pinned medic and escort them to extraction.',
    objectiveType: 'rescue',
    width: 360,
    height: 640,
    playerSpawn: { x: 310, y: 582 },
    ally: { x: 76, y: 300, width: 34, height: 38 },
    flag: { x: 300, y: 78, width: 42, height: 50 },
    groundPatches: [
      ...BASE_PATCHES,
      { x: 78, y: 302, width: 86, height: 66, color: 0xf1eee2, alpha: 0.22 },
    ],
    terrains: [
      { id: 'aid-road', type: 'road', x: 296, y: 332, width: 58, height: 500, speedMultiplier: 1.07 },
      { id: 'aid-mud', type: 'mud', x: 154, y: 390, width: 116, height: 128, speedMultiplier: 0.72 },
      { id: 'aid-trench', type: 'trench', x: 154, y: 214, width: 136, height: 58, speedMultiplier: 0.62 },
    ],
    decorations: [
      ...BASE_DECORATIONS,
      { type: 'crate', x: 72, y: 344 },
      { type: 'sandbag', x: 110, y: 300 },
      { type: 'crate', x: 292, y: 132 },
    ],
    obstacles: [
      { x: 222, y: 524, width: 116, height: 24 },
      { x: 104, y: 472, width: 104, height: 24 },
      { x: 236, y: 374, width: 118, height: 24 },
      { x: 104, y: 254, width: 112, height: 24 },
      { x: 244, y: 190, width: 104, height: 24 },
    ],
    enemies: [
      { x: 132, y: 520, axis: 'horizontal', range: 58, speed: 25, visionRange: 148, visionAngle: 54, attackCooldownMs: 1260 },
      { x: 250, y: 318, axis: 'vertical', range: 74, speed: 27, visionRange: 158, visionAngle: 58, attackCooldownMs: 1140 },
      { x: 96, y: 176, axis: 'horizontal', range: 48, speed: 22, visionRange: 140, visionAngle: 52, attackCooldownMs: 1340, health: 1 },
    ],
  },
  {
    id: 'level-09',
    name: 'Artillery Line',
    objectiveText: 'Silence all three guns before extraction.',
    objectiveType: 'multi-sabotage',
    width: 360,
    height: 640,
    playerSpawn: { x: 60, y: 582 },
    targets: [
      { x: 78, y: 206, width: 38, height: 38 },
      { x: 180, y: 326, width: 38, height: 38 },
      { x: 286, y: 206, width: 38, height: 38 },
    ],
    flag: { x: 180, y: 78, width: 44, height: 52 },
    groundPatches: [
      ...BASE_PATCHES,
      { x: 180, y: 324, width: 118, height: 86, color: 0x4d3726, alpha: 0.24 },
    ],
    terrains: [
      { id: 'artillery-road', type: 'road', x: 180, y: 336, width: 60, height: 498, speedMultiplier: 1.06 },
      { id: 'artillery-mud-west', type: 'mud', x: 76, y: 272, width: 94, height: 122, speedMultiplier: 0.72 },
      { id: 'artillery-mud-east', type: 'mud', x: 286, y: 272, width: 94, height: 122, speedMultiplier: 0.72 },
      { id: 'artillery-trench', type: 'trench', x: 180, y: 452, width: 144, height: 58, speedMultiplier: 0.62 },
    ],
    decorations: [
      ...BASE_DECORATIONS,
      { type: 'crate', x: 78, y: 252 },
      { type: 'crate', x: 180, y: 374 },
      { type: 'crate', x: 286, y: 252 },
      { type: 'sandbag', x: 180, y: 278 },
    ],
    obstacles: [
      { x: 116, y: 528, width: 116, height: 24 },
      { x: 280, y: 528, width: 96, height: 24 },
      { x: 74, y: 404, width: 102, height: 24 },
      { x: 286, y: 404, width: 102, height: 24 },
      { x: 180, y: 254, width: 118, height: 24 },
      { x: 180, y: 150, width: 128, height: 24 },
    ],
    enemies: [
      { x: 184, y: 500, axis: 'horizontal', range: 76, speed: 29, visionRange: 164, visionAngle: 58, attackCooldownMs: 1100 },
      { x: 78, y: 322, axis: 'vertical', range: 64, speed: 25, visionRange: 150, visionAngle: 54, attackCooldownMs: 1240 },
      { x: 286, y: 322, axis: 'vertical', range: 64, speed: 25, visionRange: 150, visionAngle: 54, attackCooldownMs: 1240 },
      { x: 180, y: 202, axis: 'horizontal', range: 72, speed: 27, visionRange: 156, visionAngle: 58, attackCooldownMs: 1160, health: 2 },
    ],
  },
  {
    id: 'level-10',
    name: 'Airfield Breakout',
    objectiveText: 'Disable the tower and fuel drums, then capture the runway flag.',
    objectiveType: 'multi-sabotage',
    width: 360,
    height: 640,
    playerSpawn: { x: 180, y: 582 },
    targets: [
      { x: 72, y: 182, width: 40, height: 40 },
      { x: 286, y: 182, width: 40, height: 40 },
    ],
    flag: { x: 180, y: 72, width: 46, height: 54 },
    groundPatches: [
      { x: 94, y: 112, width: 98, height: 54, color: 0xe5d391, alpha: 0.5 },
      { x: 270, y: 112, width: 98, height: 54, color: 0xe5d391, alpha: 0.5 },
      { x: 180, y: 498, width: 128, height: 72, color: 0x9e7b51, alpha: 0.34 },
      { x: 180, y: 300, width: 188, height: 58, color: 0xd7ad5f, alpha: 0.3 },
    ],
    terrains: [
      { id: 'airfield-runway', type: 'road', x: 180, y: 330, width: 78, height: 522, speedMultiplier: 1.12 },
      { id: 'airfield-left-mud', type: 'mud', x: 74, y: 390, width: 96, height: 154, speedMultiplier: 0.72 },
      { id: 'airfield-right-mud', type: 'mud', x: 286, y: 390, width: 96, height: 154, speedMultiplier: 0.72 },
      { id: 'airfield-forward-trench', type: 'trench', x: 180, y: 232, width: 146, height: 58, speedMultiplier: 0.62 },
    ],
    decorations: [
      ...BASE_DECORATIONS,
      { type: 'crate', x: 72, y: 228 },
      { type: 'crate', x: 286, y: 228 },
      { type: 'sandbag', x: 180, y: 184 },
      { type: 'sandbag', x: 180, y: 452 },
      { type: 'rock', x: 316, y: 118 },
    ],
    obstacles: [
      { x: 84, y: 536, width: 118, height: 24 },
      { x: 276, y: 536, width: 118, height: 24 },
      { x: 180, y: 448, width: 128, height: 24 },
      { x: 74, y: 334, width: 104, height: 24 },
      { x: 286, y: 334, width: 104, height: 24 },
      { x: 180, y: 258, width: 126, height: 24 },
      { x: 180, y: 136, width: 118, height: 24 },
    ],
    enemies: [
      { x: 180, y: 500, axis: 'horizontal', range: 86, speed: 30, visionRange: 170, visionAngle: 60, attackCooldownMs: 1060 },
      { x: 72, y: 386, axis: 'vertical', range: 72, speed: 27, visionRange: 158, visionAngle: 56, attackCooldownMs: 1160 },
      { x: 286, y: 386, axis: 'vertical', range: 72, speed: 27, visionRange: 158, visionAngle: 56, attackCooldownMs: 1160 },
      { x: 92, y: 150, axis: 'horizontal', range: 54, speed: 24, visionRange: 148, visionAngle: 54, attackCooldownMs: 1280, health: 2 },
      { x: 268, y: 150, axis: 'horizontal', range: 54, speed: 24, visionRange: 148, visionAngle: 54, attackCooldownMs: 1280, health: 2 },
    ],
  },
];

export const RANGER_LEVEL_01 = RANGER_LEVELS[0];
